import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { downloadSql, getShiftInfoList } from '@/api/bairun/bairunData.js'; //  此处请自行替换地址

import { getSellerList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo'; //  此处请自行替换地址

import * as DateUtil from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'DownloadTaskAdd',
  components: {},
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      loading: false,
      sellerOptions: [],
      sellerOptionsOrigin: [],
      stationOptions: [],
      stationOptionsOrigin: [],
      startShiftOptions: '',
      startShiftDate: '',
      endShiftOptions: '',
      endShiftDate: '',
      formData: {
        id: 0,
        startTime: '',
        endTime: '',
        afterTime: '',
        stationId: 0,
        sellerId: 0,
        shiftNoStart: '',
        shiftNoEnd: ''
      },
      endTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return !DateUtil.isBeforeDate(_this.formData.startTime, time.Format('yyyy-MM-dd hh:mm:ss'), _this.searchInfo.timeLimit);
        }
      },
      afterTimePickerOptions: {
        disabledDate: function disabledDate(time) {
          // return ture表示日期不可选
          return time.getTime() <= new Date(_this.formData.endTime).getTime();
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('activated');

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var sellerOptions, stationOptions;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('created');

              if (_this.$route.params) {
                _this.searchInfo = _this.$route.params.row;
              }

              _context2.next = 4;
              return getSellerList({
                page: 1,
                pageSize: 999999,
                sellerSource: 1,
                donNotShowLoading: true
              });

            case 4:
              sellerOptions = _context2.sent;
              _this2.sellerOptionsOrigin = sellerOptions.data.list;
              _context2.next = 8;
              return getStationBaseInfoList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 8:
              stationOptions = _context2.sent;
              _this2.stationOptionsOrigin = stationOptions.data.list;
              _this2.formData.id = _this.searchInfo.ID;

              if (_this.searchInfo.isNeedStationFilter == 1) {
                _this.searchInfo.limitStations = _this.searchInfo.limitStations.split(',');

                if (_this.searchInfo.limitStations.length === 1 && _this.searchInfo.limitStations[0] == 0) {
                  _this2.stationOptions = _this2.stationOptionsOrigin;
                } else {
                  _this2.stationOptions = _this2.stationOptionsOrigin.filter(function (item) {
                    return _this.searchInfo.limitStations.includes(item.ID + '');
                  });
                }
              }

              if (_this.searchInfo.isNeedSellerFilter == 1) {
                _this.searchInfo.limitSellers = _this.searchInfo.limitSellers.split(',');

                if (_this.searchInfo.limitSellers.length === 1 && _this.searchInfo.limitSellers[0] == 0) {
                  _this2.sellerOptions = _this2.sellerOptionsOrigin;
                } else {
                  _this2.sellerOptions = _this2.sellerOptionsOrigin.filter(function (item) {
                    return _this.searchInfo.limitSellers.includes(item.sellerId + '');
                  });
                }
              }

              if (_this.searchInfo.isNeedTimeFilter == 1) {
                _this2.formData.startTime = DateUtil.beforeDiffDate(new Date().Format('yyyy-MM-dd hh:mm:ss'), _this.searchInfo.timeLimit);
              }

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onStartShiftDateChange: function onStartShiftDateChange(time) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getShiftInfoList({
                  page: 1,
                  pageSize: 10,
                  stationId: _this3.formData.stationId,
                  shiftDate: DateUtil.formatTimeToStr(time, 'yyyyMMdd')
                });

              case 2:
                res = _context3.sent;

                if (res.code == 0) {
                  _this3.startShiftOptions = res.data.list;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onEndShiftDateChange: function onEndShiftDateChange(time) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getShiftInfoList({
                  page: 1,
                  pageSize: 10,
                  stationId: _this4.formData.stationId,
                  shiftDate: DateUtil.formatTimeToStr(time, 'yyyyMMdd')
                });

              case 2:
                res = _context4.sent;

                if (res.code == 0) {
                  _this4.endShiftOptions = res.data.list;
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 提交
    onSave: function onSave() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this5.loading) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                _this5.loading = true;
                _context5.next = 5;
                return downloadSql(_this5.formData);

              case 5:
                res = _context5.sent;

                if (res.code != 0) {
                  _this5.loading = false;
                } else {
                  _this5.$message({
                    type: 'success',
                    message: res.msg
                  });

                  setTimeout(function () {
                    _this5.$router.push({
                      name: 'DownloadCenter',
                      query: {},
                      params: {}
                    });
                  }, 3000);
                }

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};